package com.wintermar.inspection.feature.presentation.inspection.complete.widget.confirm_approval

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.component.modal.ModalDialog

@Composable
actual fun ConfirmApprovalModal(
    show: Boolean,
    gradientColors: List<Color>,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {
    ModalDialog(
        show = show,
        gradientColors = gradientColors,
        onDismiss = onDismiss
    ) {
        ConfirmApproval(
            onConfirm = onConfirm
        )
    }
}
